import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const PendingOrdersIcon = (props: Omit<SvgIconProps, 'viewBox'>) => {
    return (
        <SvgIcon viewBox='0 0 82 86' {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M0 9.2663C0 4.14866 4.30362 0 9.6124 0H52.3876C57.6964 0 62 4.14866 62 9.2663V84.3233C62 84.6203 61.9855 84.914 61.9572 85.2037L51.6668 74.1305L41.3335 85.25H41.3332L30.9998 74.1305L20.6666 85.2499L10.3333 74.1305L0.0428381 85.2039C0.0144943 84.9141 0 84.6203 0 84.3233V9.2663Z" fill="#2EF9F9" />
            <path fillRule="evenodd" clipRule="evenodd" d="M0 9.2663C0 4.14866 4.30362 0 9.6124 0H52.3876C57.6964 0 62 4.14866 62 9.2663V84.3233C62 84.6203 61.9855 84.914 61.9572 85.2037L51.6668 74.1305L41.3335 85.25H41.3332L30.9998 74.1305L20.6666 85.2499L10.3333 74.1305L0.0428381 85.2039C0.0144943 84.9141 0 84.6203 0 84.3233V9.2663Z" fill="url(#paint0_linear)" />
            <rect x="22" y="25" width="23" height="27" fill="#554DF0" />
            <path d="M31 19C18.3371 19 8 29.5618 8 42.5C8 55.4382 18.3371 66 31 66C43.6629 66 54 55.4382 54 42.5C54 29.5618 43.7921 19 31 19ZM40.691 46.0646H31.1292C29.191 46.0646 27.6405 44.4803 27.6405 42.5V30.486C27.6405 28.5056 29.191 26.9213 31.1292 26.9213C33.0674 26.9213 34.618 28.5056 34.618 30.486V39.0674H40.8202C42.7584 39.0674 44.309 40.6517 44.309 42.632C44.0506 44.4803 42.5 46.0646 40.691 46.0646Z" fill="url(#paint1_radial)" />
            <defs>
                <linearGradient id="paint0_linear" x1="18.1656" y1="5.42994" x2="18.1656" y2="85.25" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2EF9F9" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <radialGradient id="paint1_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(31 42.5) rotate(90) scale(23.5 23)">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#554DF0" />
                </radialGradient>
            </defs>
        </SvgIcon>
    );
};

export default PendingOrdersIcon;
